export * as middlewares from "./middlewares";
export * as selectors from "./selectors";
export { actions } from "./store";
import reducer from "./store";

export default reducer;
